<template>
  <div
    class="d-book-mark-as-spam modal text-black-base"
    :class="{ 'active': book }"
  >
    <div class="overlay" />

    <div class="modal-content">
      <div class="modal-header">
        <h4>Mark as spam</h4>
        <a
          class="button button-yellow button-icon button-close-white button-close-modal"
          @click="dismiss"
        />
      </div>

      <div
        v-if="book"
        class="modal-body loadable"
        :class="{ 'loading': isProcessing }"
      >
        <div
          v-if="isProcessing"
          class="loading-content"
        >
          <DuiLoadingIndicator size="lg" />
          <p class="space-top-2em">
            Submitting report...
          </p>
        </div>

        <div class="loaded-content">
          <p class="space-bottom-2em">
            <i>{{ book.title }}</i>
            will be immediately removed from the review pool.
            Please indicate a reason why you would like to mark
            this book as spam.
          </p>

          <form>
            <div class="form-group">
              <label for="reason">Reason</label>

              <DuiDropdown
                name="reason"
                placeholder="Please select a reason"
                store-load-key="Reviews/get-report-spam-reasons"
                store-update-key="Reviews/selectReportSpamReason"
              />
            </div>

            <div class="form-group">
              <label for="description">Further details</label>
              <textarea
                v-model="description"
                name="description"
                placeholder="Provide further details..."
              />
            </div>

            <div class="button-pair right">
              <button
                type="button"
                @click="dismiss"
              >
                Cancel
              </button>

              <button
                class="button-yellow"
                :disabled="!selectedReason"
                type="button"
                @click="submit"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import { getErrorMessage } from '@d-shared/utils/errors';
import modalMixin from '@d-mixins/modal';
import libraryService from '@d-services/library-service/library-service';

export default {
  mixins: [
    modalMixin,
  ],
  props: {
    book: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isProcessing: false,
    description: null,
  }),
  computed: {
    reasons() {
      return this.$store.getters['Reviews/get-report-spam-reasons'];
    },
    selectedReason() {
      return this.$store.getters['Reviews/get-selected-spam-report-reason'];
    },
  },
  mounted() {
    this.loadReasons();
    this.reset();
  },
  methods: {
    dismiss() {
      this.$emit('dismiss-report-spam');
      this.reset();
    },
    async loadReasons() {
      if (this.reasons) {
        return;
      }

      const reasons = await libraryService.getReportSpamReasons();
      this.$store.dispatch('Reviews/setAvailableSpamReasons', reasons);
    },
    reset() {
      this.isProcessing = false;
      this.description = null;
      this.$store.dispatch('Reviews/selectReportSpamReason', null);
    },
    async submit() {
      this.isProcessing = true;

      const data = {
        book_id: this.book.slug,
        book_report: {
          reason: this.selectedReason.text,
        },
      };

      if (this.description) {
        data.book_report.description = this.description;
      }

      try {
        await libraryService.reportSpam(data);
        Vue.duiNotificationManager.success('Spam reported.');
        this.$emit('book-reported-as-spam', this.book);
        this.dismiss();
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }
    },
  },
};
</script>
